/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SideModal.vue?vue&type=template&id=095aacc6&scoped=true"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"
import style0 from "./SideModal.vue?vue&type=style&index=0&id=095aacc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095aacc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095aacc6')) {
      api.createRecord('095aacc6', component.options)
    } else {
      api.reload('095aacc6', component.options)
    }
    module.hot.accept("./SideModal.vue?vue&type=template&id=095aacc6&scoped=true", function () {
      api.rerender('095aacc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/SideModal.vue"
export default component.exports